export const TRANSECT_REVIEW_CODE_NARRATIVE = 'narrative';
export const TRANSECT_REVIEW_CODE_PHOTOS = 'photos';
export const TRANSECT_REVIEW_CODE_STEM_LENGTH = 'stem-length';
export const TRANSECT_REVIEW_CODE_DBH = 'dbh';
export const TRANSECT_REVIEW_CODE_INVASIVE_COVER = 'invasive-cover';
export const TRANSECT_REVIEW_CODE_CANOPY = 'canopy';
export const TRANSECT_REVIEW_CODE_INSTREAM = 'instream';
